<script lang="ts">
	import type { HorizontalStackedBarChartDataset } from '$lib/components/route-details/types';

	export let datasets: HorizontalStackedBarChartDataset[];
	export let showBarChart = false;
	export let classes: string = '';

	$: totalNb = datasets.reduce((acc, dataset) => acc + dataset.nb, 0);

	function getNbPercentage(nb: number) {
		return (nb / totalNb) * 100;
	}

	$: datasetsEnriched = datasets.map((dataset) => {
		return { ...dataset, percent: getNbPercentage(dataset.nb) };
	});

	$: showChartAndColors = datasetsEnriched.filter(dataset => dataset.nb > 0).length > 1;
</script>

<div class="grid gap-2 text-md {classes}">
	{#if showChartAndColors && showBarChart}
		<div class="w-full flex gap-0.5">
			<!-- eslint-disable-next-line svelte/require-each-key -->
			{#each datasetsEnriched as dataset}
				<div
					class="h-8 rd-1 {dataset.colorClass ? dataset.colorClass : 'bg-[var(--color)]'}"
					style="width: {dataset.percent}%; --color: {dataset.color};"
				/>
			{/each}
		</div>
	{/if}
	<!-- eslint-disable-next-line svelte/require-each-key -->
	{#each datasetsEnriched as dataset}
		<div class="flex justify-between items-center" style="--color: {dataset.color}">
			<div class="flex items-center gap-1">
				{#if showChartAndColors}
					<div
						class="h-3 w-3 rd-0.5 {dataset.colorClass ? dataset.colorClass : 'bg-[var(--color)]'}"
					/>
				{/if}
				{dataset.label}
			</div>
			<div class="text-bold">
				{#if dataset.withCustomDescription}
					<slot name="description" {dataset}>
						{dataset.description}
					</slot>
				{:else}
					{dataset.description}
				{/if}
			</div>
		</div>
	{/each}
</div>
